import ModalCompositionGroupsLookup from '.';

export const ROUTE_BY_RESOURCE_TYPE: Record<
  ModalCompositionGroupsLookup['data']['resourceType'],
  string
> = {
  service: '/work/item/groups',
  input: '/resource/groups',
};

export const FILTER_KEY_BY_RESOURCE_TYPE: Record<
  ModalCompositionGroupsLookup['data']['resourceType'],
  string
> = {
  service: 'workItemId',
  input: 'resourceGroupId',
};
